import "normalize.css";
import "flexboxgrid2";
import "swiper/dist/css/swiper.css";

import Vue from "vue";
import App from "./App.vue";
import "./styles/main.scss";
import VueAwesomeSwiper from "vue-awesome-swiper";
import FadeAnimation from "./directives/FadeAnimation";
import "./js/Parallax.js";

Vue.config.productionTip = true;

Vue.use(VueAwesomeSwiper);
Vue.directive("fade", FadeAnimation);

new Vue({
  render: h => h(App)
}).$mount("#app");
